import React from "react";

export default function Spinner({ label = "Loading…" }) {
    return (
        <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">{label}</span>
            </div>
        </div>
    );
}
